// extracted by mini-css-extract-plugin
export var mt0 = "fp-Fy";
export var mt1 = "fp-Gy";
export var mt2 = "fp-Hy";
export var mt3 = "fp-Iy";
export var mt4 = "fp-Jy";
export var mt5 = "fp-Ky";
export var mt6 = "fp-Ly";
export var socialIcons = "fp-My";
export var socialIcons__link = "fp-Oy";
export var socialIcons__link__icon = "fp-Py";
export var socialIcons__listItem = "fp-Ny";